import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function CookiesPage() {
  return (
    <LegalPageLayout title="Çerez Politikası">
      <p>Bu Çerez Politikası, Atak Sistem Enerji web sitesinde kullanılan çerezler hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.</p>

      <h4>1. Çerez Nedir?</h4>
      <p>Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin daha verimli çalışmasını ve kullanıcı deneyiminin iyileştirilmesini sağlar.</p>

      <h4>2. Kullanılan Çerez Türleri</h4>
      <ul>
        <li><strong>Zorunlu Çerezler:</strong> Web sitesinin düzgün çalışması için gerekli olan çerezlerdir.</li>
        <li><strong>Analitik Çerezler:</strong> Ziyaretçi trafiğini analiz etmek ve site performansını ölçmek için kullanılır.</li>
        <li><strong>İşlevsel Çerezler:</strong> Tercihlerinizin hatırlanmasını sağlar.</li>
      </ul>

      <h4>3. Çerezlerin Kullanım Amaçları</h4>
      <p>Web sitemizde çerezler şu amaçlarla kullanılmaktadır:</p>
      <ul>
        <li>Site performansını ve kullanıcı deneyimini iyileştirmek</li>
        <li>Ziyaretçi istatistiklerini analiz etmek</li>
        <li>Güvenlik önlemlerini artırmak</li>
      </ul>

      <h4>4. Çerezleri Kontrol Etme</h4>
      <p>Tarayıcı ayarlarınızdan çerezleri engelleyebilir veya silebilirsiniz. Ancak bu durumda web sitemizin bazı özellikleri düzgün çalışmayabilir.</p>

      <h4>5. İletişim</h4>
      <p>Çerez politikamız hakkında sorularınız için WhatsApp veya telefon üzerinden bizimle iletişime geçebilirsiniz.</p>
    </LegalPageLayout>
  );
}